import script from "./ActiveOffersView.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveOffersView.vue?vue&type=script&setup=true&lang=js"

import "./ActiveOffersView.vue?vue&type=style&index=0&id=02b3eda2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b3eda2"]])

export default __exports__